import { useMemo } from "react";
import { useWatch } from "react-hook-form";
import { useAtomValue } from "jotai";

import { usePrintOnDemandProduct } from "@design-lab/entities/product";
import { useCompositionForm } from "./useCompositionForm";
import { selectedCompositionOverrideAtom } from "./state";

export function useCurrentComposition() {
  const { form } = useCompositionForm();
  const compositionOverrideId = useAtomValue(selectedCompositionOverrideAtom);

  const currentCompositionId = useWatch({
    control: form.control,
    name: "currentCompositionId"
  });

  const currentCompositionForm = form
    .getValues("addedCompositions")
    ?.find(c => c.id === currentCompositionId);

  const { data: product } = usePrintOnDemandProduct(currentCompositionForm?.catalogId);
  const currentComposition = product?.compositions.find(c => c.id === currentCompositionId);

  // Preview composition is only set when hovering over a color
  const previewComposition = compositionOverrideId
    ? product?.compositions.find(c => c.id === compositionOverrideId)
    : undefined;

  const currentCompositionIndex = form
    .getValues("addedCompositions")
    .findIndex(c => c.id === currentComposition?.id);
  const compositionError =
    currentCompositionIndex >= 0
      ? form.formState.errors.addedCompositions?.[currentCompositionIndex]?.message
      : undefined;

  // Get the selected model from surface image variants based on user preferences
  const selectedModelVariant = useMemo(() => {
    const userPreferences = (product as any)?.userPreferences?.mockup;

    if (!userPreferences || !product?.surfaceImageOptions?.front) {
      return null;
    }

    const { gender, race } = userPreferences;
    return (
      product.surfaceImageOptions.front.find(
        variant => variant.gender === gender && variant.race === race
      ) || null
    );
  }, [product]);

  return {
    currentProduct: product,
    currentComposition,
    previewComposition,
    compositionError,
    selectedModelVariant
  };
}
